import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BlockAbstractComponent, AuthService, ParserService} from '@gallaghercp/core-frontend';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
    standalone: false,
    selector: 'core-block-video-custom',
    templateUrl: './block-video-custom.component.html',
})


export class BlockVideoCustomComponent extends BlockAbstractComponent implements OnInit {
    @ViewChild('video') video!: ElementRef;

    isPlaying = false;
    videoSrc!: SafeResourceUrl;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        private sanitizer: DomSanitizer
    ) {
        super(
            parser,
            auth,
        );
    }

    override ngOnInit() {
        super.ngOnInit();
        this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.block.data.url);
    }

    playVideo() {
        if (!this.isPlaying) {
            this.video.nativeElement.play();
        }

        this.isPlaying = true;
    }
}
